// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { setWeekYear as fn } from "../setWeekYear.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const setWeekYear = convertToFP(fn, 2);

// Fallback for modularized imports:
export default setWeekYear;
